/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend Developer
 * @Email: sgarcia@ibl.mx
 */

import AddEmployeesModalApp from '../Functionality/AddEmployeesModalApp';
import { TABLES } from '../../../../Apis/Tables';
import { userListToLabelEmailPhoneValue } from '../../../../Apis/functions';
import CustomModal from '../../../../components/Modal/CustomModal';
import CustomAddChipSearch from '../../../../components/CustomAddChipSearch';
import NotInformation from '../../../../components/NotInformation';
import CustomCard from '../../../../components/CustomCard';
import CustomMediumChip from '../../../../components/CustomMediumChip';
import { Box } from '@mui/material';
import { EmailSubsectionChip, PersonChipBlack, PhoneSubsectionChip } from '../../../../components/buttons/IconButtons';
import { POSITION_MODEL } from '../../../../Helpers/PositionModel';
import CustomChip from '../../../../components/CustomChip';
import { colors } from '../../../../enums/colors';
import CustomAutocompleteSearch from '../../../../components/CustomAutocompleteSearch';
import { SEARCH_USERS_MODEL } from '../../../../components/table/Model/TableModel';

const AddEmployeesModal = ({ show, onHide, selectedId, setModified, modified }) => {
    const { handleAdd, selectedEmployee, setSelectedEmployee, t, id } = AddEmployeesModalApp({
        onHide,
        selectedId,
        setModified,
        modified,
        show,
    });

    return (
        <CustomModal
            show={show}
            title={t('add_employee')}
            size='md'
            onHide={() => {
                onHide();
            }}
            onConfirm={() => handleAdd(selectedEmployee)}
        >
            <CustomAutocompleteSearch
                id='slt_aem_add_vehicle'
                label='employee'
                itemSelected={selectedEmployee}
                setItemSelected={(employee) => {
                    if (!employee) return;
                    setSelectedEmployee((prev) =>
                        prev.some((e) => e.id === employee.id) ? prev : [...prev, employee],
                    );
                }}
                userTypeIdsSearch={[]}
                required
                keyId='userId'
                bodyApi={{...SEARCH_USERS_MODEL, model:TABLES.USER_NOT_ASSIGNED_TO_CONTRACT, modelId: id }}
                model={TABLES.USER_NOT_ASSIGNED_TO_CONTRACT}
                listTransform={userListToLabelEmailPhoneValue}
                placeholder={t('search_employee_by_name_email_or_phone')}
                reset
            />

            <CustomCard classes='mt-3' classCard={'card-border-8px'} classContent={'p-0'}>
                <div className='mt-3 mx-3 mb-2'>
                    <div className='d-flex align-items-center gap-2 ml-2 mr-2 mb-2'>
                        <p className={'font-color-general-950 fs-14px ml-2 ibl-font-w-600'}>
                            {t('selected_employees')}
                        </p>
                        <CustomChip
                            background={colors.shades200}
                            legend={`${selectedEmployee?.length || 0}`}
                            border={colors.shades300}
                            fontColor={colors.shades500}
                        />
                    </div>
                    <div className={'border-bottom-shades-300'} />
                </div>

                {selectedEmployee?.length > 0 ? (
                    <div className='d-flex flex-column gap-4 p-2 m-2'>
                        {selectedEmployee.map((employee) => (
                            <CustomMediumChip
                                key={employee.id}
                                title={employee.label}
                                completeWidth
                                showAvatar
                                Icon={PersonChipBlack}
                                iconPosition={POSITION_MODEL.LEFT}
                                onClickClose={() =>
                                    setSelectedEmployee((prev) => prev.filter((item) => item.id !== employee.id))
                                }
                            >
                                <Box className='d-flex justify-content-between align-items-center pt-3'>
                                    <Box className='d-flex  justify-content-between gap-4'>
                                        {employee.email && (
                                            <Box className='d-flex align-items-center gap-1 '>
                                                <EmailSubsectionChip />
                                                <span className='text-shades-600'>{employee.email}</span>
                                            </Box>
                                        )}

                                        {employee.phone && (
                                            <Box className='d-flex align-items-center gap-1'>
                                                <PhoneSubsectionChip />
                                                <span className='text-shades-600'>{employee.phone}</span>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </CustomMediumChip>
                        ))}
                    </div>
                ) : (
                    <div className='m-3'>
                        <NotInformation text={t('no_employees_added')} card />
                    </div>
                )}
            </CustomCard>
        </CustomModal>
    );
};

export default AddEmployeesModal;
